import { lazy, Suspense } from "react";
import { PATHS } from "@/lib/router";
import { RouteLoading } from "@/components/common";

const CreateSurveyPage = lazy(() => import("./pages/CreateSurveyPage"));
const QuestionLibraryPage = lazy(() => import("./pages/QuestionLibraryPage"));
const TakeSurveyPage = lazy(() => import("./pages/TakeSurveyPage"));
const SurveyLibraryPage = lazy(() => import("./pages/SurveyLibraryPage"));
const SurveyResponsesPage = lazy(() => import("./pages/SurveyResponsesPage"));
const ResponsesDetailPage = lazy(() => import("./pages/ResponsesDetailPage"));

export const surveyManagementRoutes = [
  {
    path: PATHS.SURVEY_LIBRARY,
    element: <SurveyLibraryPage />,
    handle: { permission: { resource: "survey_library", action: "view" } },
  },
  {
    path: PATHS.QUESTION_LIBRARY,
    element: <QuestionLibraryPage />,
    handle: { permission: { resource: "question_library", action: "view" } },
  },
  {
    path: PATHS.SURVEY_RESPONSES,
    element: <SurveyResponsesPage />,
    handle: { permission: { resource: "survey_responses", action: "view" } },
  },
  {
    path: PATHS.RESPONSES_DETAIL,
    element: <ResponsesDetailPage />,
    handle: { permission: { resource: "survey_responses", action: "view" } },
  },
  {
    path: PATHS.CREATE_NEW_SURVEY,
    element: <CreateSurveyPage />,
    handle: { permission: { resource: "survey_library", action: "create" } },
  },
  {
    path: PATHS.EDIT_SURVEY,
    element: <CreateSurveyPage />,
    handle: { permission: { resource: "survey_library", action: "create" } },
  },
];

export const surveyLibraryPublicRoutes = [
  {
    path: PATHS.TAKE_SURVEY,
    element: (
      <Suspense fallback={<RouteLoading />}>
        <TakeSurveyPage />
      </Suspense>
    ),
  },
];
